import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictSigningPath as dictData } from '../../queries/getDataForDropdowns'

const namePlaceholder = props => (
  <Query
    query={dictData}
    variables={{ companyId: props.companyId }}
    errorPolicy="all"
    fetchPolicy="network-only"
  >
    {({ loading, error, data }) => {
      // console.log(props)
      if (error) return <p>Database connection error</p>
      if (loading) {
        return <p>Loading...</p>
      } else {
        const {
          helperText = 'Signing Path ...',
          labelText = '',
          ...rest
        } = props
        // if (process.env === 'development')
        // console.log(data)
        return (
          <AutoCompleteDropdown
            options={data.signingPaths.map(d => ({ ...d, label: d.name }))}
            placeholder={helperText}
            labelText={labelText}
            {...rest}
          />
        )
      }
    }}
  </Query>
)

namePlaceholder.propTypes = {
  // classes: PropTypes.object.isRequired
}

export default graphql(dictData)(namePlaceholder)
